import { object, SchemaOf, string } from 'yup';

import { REQUIRED_FIELD } from '@/config/text.const';


export type Fields = {
  contractNumber: string;
  currency: string;
  clientDatabaseID: string;
};


export const validationSchema: SchemaOf<Fields> = object().shape({
  contractNumber: string()
    .min(1, 'Must be at least ${min} character')
    .max(200, 'Must be maximum ${max} characters')
    .required(REQUIRED_FIELD)
    .nullable(),
  currency: string().required(),
  clientDatabaseID: string().required()
});

